import { Button, Eyedrop, Text } from '@sparemin/blockhead';
import * as React from 'react';

import { block } from './utils';

type SampleColorPickerProps = {
  onColorPick: (color: string) => void;
};

const SampleColorPicker: React.FC<SampleColorPickerProps> = ({
  onColorPick,
}) => {
  const handleEyeDropperColorPick = async () => {
    if (!('EyeDropper' in window)) {
      return;
    }

    try {
      const eyeDropper = new window.EyeDropper();
      const { sRGBHex } = await eyeDropper.open();

      onColorPick(sRGBHex);
    } catch (err) {
      throw new Error(err);
    }
  };

  if ('EyeDropper' in window) {
    return (
      <Button
        fluid
        size="small"
        startIcon={<Eyedrop width={12} height={12} />}
        className={block('sample-color-button')}
        onPress={handleEyeDropperColorPick}
      >
        sample color
      </Button>
    );
  }

  return (
    <>
      <Text
        as="label"
        variant="label"
        htmlFor="color-input"
        letterSpacing="2px"
        textTransform="uppercase"
        size={12}
        weight={700}
        className={block('sample-color-label')}
      >
        <Eyedrop width={12} height={12} />
        Sample color
      </Text>

      <input
        id="color-input"
        type="color"
        className={block('sample-color-input')}
        onChange={e => onColorPick(e.target.value)}
      />
    </>
  );
};

export default SampleColorPicker;
